'use client'

import dynamic from 'next/dynamic'
import classNames from 'classnames'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import { MARKET_CUTOFF_TIME, shouldShowBanner } from './utils'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'

const Banner = dynamic(() =>
  import('@dustin-web/microsite-components/src/banners/banner').then(m => m.Banner)
)

type Props = {
  fullWidth?: boolean
  compact?: boolean
}

const ShippingCutoffBanner = ({ fullWidth, compact }: Props) => {
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()

  const { enabled: isShippingCutoffBannerEnabled } = useFeatureFlag(
    'ab-test-shipping-cutoff-banner'
  )

  if (!shouldShowBanner(sourcingCompany)) {
    return null
  }

  if (!isShippingCutoffBannerEnabled) {
    return null
  }

  return (
    <Banner
      color="light-green"
      closeable={false}
      fullWidth={fullWidth}
      className={classNames({ compact: compact })}>
      <div className="d-flex align-items-center">
        <Icon name="clock" className={classNames('i-16 u-mr-8', { 'i-20': fullWidth })} />
        <div className="text-button-container d-flex flex-column flex-md-row justify-content-md-between">
          <div className="text-block">
            <p className="u-mb-0 u-fs-14">
              {translate('Shipping_Cutoff_Banner', {
                time: MARKET_CUTOFF_TIME.get(sourcingCompany),
              })}
            </p>
          </div>
        </div>
      </div>
    </Banner>
  )
}

export default ShippingCutoffBanner
